<template>
  <v-main class="page-account">
    <AppBar />
    <v-layout fill-height column>

      <v-container fluid>
        <div class="account-title-block">
          <h3 class="tit">
            <span class="tit-point">닉네임</span> 입력
          </h3>
          <p class="desc">
            서비스는 익명으로 진행되어 모든 상담은 비밀보장됩니다.<br />
            사용할 닉네임을 정해주세요! :)
          </p>
        </div>
        <v-form class="form-item" v-model="valid">
          <label class="label">닉네임</label>
          <div class="input-group">
            <v-text-field solo flat filled
                          ref="nickname"
                          v-model.trim="modNickname"
                          :rules="nickname_rule"
                          required
                          placeholder="한글, 영문, 숫자 10자 이내"
                          @input="value => inputNickname(value)"
                          @keydown.space.prevent
            />
            <v-btn depressed :ripple="false" color="primary" class="btn-input" width="90"
                   @click="getUserReduNickname"
                   :disabled="modNickname === nickname || !valid || nickCheck === 0"
            >중복검사</v-btn>
          </div>
          <div class="v-messages px-3 mt-n2">
            <span class="success--text" v-if="valid && nickCheck == 0">사용가능한 닉네임입니다.</span>
            <span class="error--text" v-else-if="modNickname !== nickname && valid && nickCheck < 0">중복 검사를 진행해주세요.</span>
            <span class="error--text" v-else-if="nickCheck > 0">중복된 닉네임이 있습니다.</span>
          </div>
        </v-form>
      </v-container>
      <v-container fluid flex-fill>
        <!-- 임시 아바타 선택 -->
        <div class="account-title-block">
          <h3 class="tit">
            <span class="tit-point">프로필</span> 선택
          </h3>
          <p class="desc">서비스에서 이용할 프로필을 선택해주세요.</p>
        </div>
        <div class="text-center mb-5">
          <v-avatar size="100">
            <img :src="avatar.url" />
          </v-avatar>
        </div>
        <v-row justify="center" no-gutters>
          <v-col cols="3" class="text-center" v-for="(item, index) in avatarImages" :key="index">
            <v-avatar size="60" @click="avatar = item">
              <img :src="item.url" />
              <v-overlay absolute color="primary" :value="avatar === item">선택</v-overlay>
            </v-avatar>
          </v-col>
        </v-row>
        <!-- //임시 아바타 선택 -->

      </v-container>

      <v-footer app fixed grow color="white" class="content-footer">
        <div class="content-buttons">
          <BlackBtn x-large str="다음" :disabled="(modNickname === nickname) || (avatar === null) || !valid || nickCheck !== 0" @click="nickNameNext" />
        </div>
      </v-footer>
    </v-layout>
    <TermsSheet :sheet="sheet" @sheetClose="sheetClose" @termsDetailsOpen="termsDetailsOpen" @joinNext="joinNext"/>
    <TermsDetailsModal :dialog="termsDetailsDialog" :flag="termsFlag" @close="termsDetailsDialog = false"/>
  </v-main>
</template>
<script>
import store from "@/store"
import BlackBtn from "@/components/btns/BlackBtn"
import TermsSheet from "@/components/layout/bottomSheet/TermsSheet"
import TermsDetailsModal from "@/components/terms/TermsDetailsModal"
import {mixinRemote} from "@/mixins";

export default {
  mixins: [mixinRemote],
  data: () => ({
    sheet: false,
    termsDetailsDialog: false,
    termsFlag: null,
    usetermsApplyYn: false,
    privacyApplyYn: false,
    mktRecvApplyYn: false,
    memberNo: 0,
    updId: '',
    valid: false,
    nickCheck: -1,
    modNickname: '',
    avatar: null
  }),
  components: {
    BlackBtn,
    TermsSheet,
    TermsDetailsModal,
  },
  computed: {
    nickname_rule () {
      return [
        v => !!v || '필수 입력사항입니다.',
        v => /^[a-zA-Zㄱ-힣0-9]*$/.test(v) || '한글, 영문, 숫자만 (특수문자 제외) 입력 가능합니다.',
        v => !( v && v.length > 10) || '10자 이내로 입력 가능합니다.'
      ]
    }
  },
  created() {
    if (this.nickname) {
      this.$router.push('/')
    }
    this.memberNo = store.getters.userKey
    this.updId = store.getters.userId
    this.avatar = this.avatarImages[0]
  },
  methods: {
    inputNickname() {
      // 중복 검사 이후 input 수정시 검사 상태 default
      this.nickCheck = -1
    },
    next() {
      /* 약관 시트 */
      this.sheet = true;
    },
    sheetClose() {
      this.sheet = false;
    },
    termsDetailsOpen(index) {
      this.termsFlag = index;
      this.termsDetailsDialog = true;
    },
    joinNext(terms) {
      this.usetermsApplyYn = terms[0]; // 약관동의
      this.privacyApplyYn = terms[1];  // 개인정보
      this.mktRecvApplyYn = terms[2];  // 마케팅
      this.getUserReduNickname();
    },
    async getUserReduNickname() {
      await store.dispatch('getUserReduNickname', this.$_payload({'nickname': this.modNickname}))
          .then(res => {
            if (res.success) {
              this.nickCheck = res.data;

              if (this.nickCheck > 0) {
                // this.modNickname = null;
                this.$refs.nickname.focus()
              }
            } else {
              console.log(res.msg);
              // this.modNickname = null;
              this.$refs.nickname.focus()
            }
          })
          .catch(error => {
            console.error(error);
            // this.modNickname = null;
            this.$refs.nickname.focus()
          })
          .finally(() => {
          })
    },
    async nickNameNext() { // 닉네임 변경
      await store.dispatch('updateProfileAtchNo', this.$_payload(null, {profileAtchNo: this.avatar.key}))
          .then(async res => {
            if (res.success) {
              store.commit('setProfileAtchNo', this.avatar.key)
              await store.dispatch('setMemberInfo', this.$_payload('inData', {
                userKey: this.memberNo,
                updId: this.updId,
                nickname: this.modNickname,
                profileAtchNo: this.avatar.key
              }))
                  .then(res => {
                    if (res.success) {
                      store.commit('setNickname', this.modNickname)
                      this.$router.push({name: "travelIntro", query: {travelApplStepCd: '0001', startType: 'S'}});
                    } else {
                      console.log(res.msg)
                    }
                  })
                  .catch(error => {
                    console.error(error)
                  })
                  .finally(() => {
                  })
            } else {
              console.log(res.msg)
            }
          })
    },
    // async setMemberInsert() {  // 회원 등록
    //   await store.dispatch('setMemberInsert', this.$_payload('dmsUser', {
    //     userId: 'temp1',
    //     userName: '임시테스트',
    //     nickname: this.nickname,
    //     usetermsApplyYn: this.usetermsApplyYn,
    //     privacyApplyYn: this.privacyApplyYn,
    //     mktRecvApplyYn: this.mktRecvApplyYn
    //   }))
    //       .then(res => {
    //         if (res.success) {
    //           this.$router.push({name: "travelIntro", query: {travelApplStepCd: '0001', startType: 'S'}});
    //         } else {
    //           console.log(res.msg);
    //         }
    //       })
    //       .catch(error => {
    //         console.error(error);
    //       })
    //       .finally(() => {
    //       })
    // }
  }
}
</script>
